module.exports = __webpack_public_path__ + "img/handshake-alt-slash.2840eb6e.svg";